<template>
    <div class="turquoise-no-results-alert">
        <div v-if="type === 'sites'">
            <SvgsLineMarker />
            <h2 class="turquoise-alert-headline">No sites match these filters. Try removing a filter.</h2>
        </div>

        <div v-if="type === 'events'">
            <SvgsLineMarker />
            <h2 class="turquoise-alert-headline">No events match these filters. Try removing a filter.</h2>
        </div>

        <div v-if="type === 'tours'">
            <SvgsLineMarker />
            <h2 class="turquoise-alert-headline">No itineraries match these filters. Try removing a filter.</h2>
        </div>
        <div v-if="type === 'neighborhoods'">
            <SvgsLineMarker />
            <h2 class="turquoise-alert-headline">No neighborhoods match these filters. Try removing a filter.</h2>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        type: {
            type: String,
            required: false,
            default: 'sites',
        },
    });
    const { images } = toRefs(props);
</script>

<style lang="scss">
    .turquoise-no-results-alert {
        z-index: 2;
        position: absolute;
        top: 200px;
        right: 15px;
        left: 15px;
        padding: 30px;
        background-color: rgba($turquoise, 0.75);
        text-align: center;

        .line-marker {
            margin-bottom: 15px;
        }

        .turquoise-alert-headline {
            margin-bottom: 10px;
        }
    }
</style>
